
export class XlsFile {
  name = '';
  blob;
  size?;
  lastUpdate?;
  extension?;
}
